import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import {
  Flexbox,
  FlexboxItem
} from '@/components/flex_box'
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
require('js-base64').Base64;
// Base64.encode 加密
// Base64.decode 解密
import 'element-ui/lib/theme-chalk/index.css';
import 'lib-flexible'
import './index.scss'
Vue.config.productionTip = false
Vue.use(Element)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
